// @ts-nocheck
import { populate } from 'populate';
import type { Container, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../../common/buttons/ButtonExtraLargeLayout';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '',
      data: null,
      stateByName: {},
    },
    {
      id: 'adb9fb47-895e-411c-bee8-e6cff9eeb2a2',
      type: 'Container',
      runtimeType: null,
      name: 'wrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: null,
      stateByName: {},
    },
    {
      id: '2c4f0f75-aa1b-4259-a6a5-bf5521cd6701',
      type: 'Container',
      runtimeType: null,
      name: 'joinButton',
      className: '',
      x: 0,
      y: 627,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {},
    },
    {
      id: '4486a8da-5389-4962-94d8-7df62cfcefb7',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Leaderboard_Panel',
      parent: 'adb9fb47-895e-411c-bee8-e6cff9eeb2a2',
      data: undefined,
      stateByName: {},
    },
    {
      id: 'd60aacec-324c-4bc2-8c32-74ea70e206eb',
      type: 'Text',
      runtimeType: null,
      name: 'tournamentTitle',
      className: '',
      x: 0,
      y: 46,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'Tournament Title',
      localize: false,
      maxWidth: 0,
      maxHeight: 56,
      maxFontSize: 0,
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#eafde7',
        stroke: '#4c0501',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#4c0501',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'adb9fb47-895e-411c-bee8-e6cff9eeb2a2',
      data: undefined,
      stateByName: {},
    },
    {
      id: '3961562d-8392-4fac-8065-5d76506fa22a',
      type: 'Text',
      runtimeType: null,
      name: 'endsText',
      className: '',
      x: -54,
      y: 89,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'ends in',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: '#eafde7',
        stroke: '#4c0501',
        strokeThickness: 3,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#4c0501',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'adb9fb47-895e-411c-bee8-e6cff9eeb2a2',
      data: undefined,
      stateByName: {},
    },
    {
      id: '16a40ce0-ab33-4d32-abb7-233d04cd692a',
      type: 'Text',
      runtimeType: null,
      name: 'endsTimeText',
      className: '',
      x: 51,
      y: 89,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: '3 days',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: '#ffec1c',
        stroke: '#4c0501',
        strokeThickness: 3,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#4c0501',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'adb9fb47-895e-411c-bee8-e6cff9eeb2a2',
      data: undefined,
      stateByName: {},
    },
    {
      id: '5c847bf4-4be3-4f9e-a95c-a8bf7b2073ca',
      type: 'Container',
      runtimeType: null,
      name: 'entriesContainer',
      className: '',
      x: 0,
      y: 177,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'adb9fb47-895e-411c-bee8-e6cff9eeb2a2',
      data: undefined,
      stateByName: {},
    },
    {
      id: 'a14a98ed-e987-4ea1-aba4-61122b35a39a',
      type: 'Container',
      runtimeType: null,
      name: 'spinnerSlot',
      className: '',
      x: 0,
      y: 285,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: 'adb9fb47-895e-411c-bee8-e6cff9eeb2a2',
      data: undefined,
      stateByName: {},
    },
    {
      id: '05618ebf-0730-4eab-bf99-6873cf20d9ee',
      type: 'Layout',
      runtimeType: null,
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '2c4f0f75-aa1b-4259-a6a5-bf5521cd6701',
      data: {
        color: 'green',
      },
      stateByName: {},
    },
    {
      id: 'e6d73f53-cfa1-4c1e-a7ff-95f917e6823c',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'JOIN TOURNAMENT',
      localize: true,
      maxWidth: 393,
      maxHeight: 85,
      maxFontSize: 0,
      style: {
        fontSize: 35,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ebfee8',
        stroke: '#006f0d',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '2c4f0f75-aa1b-4259-a6a5-bf5521cd6701',
      data: undefined,
      stateByName: {},
    },
    {
      id: 'bd6a7f30-e813-4127-ac2d-25bd54902047',
      type: 'Container',
      runtimeType: null,
      name: '',
      className: 'entrySlot',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '5c847bf4-4be3-4f9e-a95c-a8bf7b2073ca',
      data: undefined,
      stateByName: {},
    },
    {
      id: '8b7338da-743c-4aea-a07d-953030af3c90',
      type: 'Container',
      runtimeType: null,
      name: '',
      className: 'entrySlot',
      x: 0,
      y: 110,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '5c847bf4-4be3-4f9e-a95c-a8bf7b2073ca',
      data: undefined,
      stateByName: {},
    },
    {
      id: '57c909c2-eb61-4b2b-9056-e3446a2c7bb4',
      type: 'Container',
      runtimeType: null,
      name: '',
      className: 'entrySlot',
      x: 0,
      y: 210,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '5c847bf4-4be3-4f9e-a95c-a8bf7b2073ca',
      data: undefined,
      stateByName: {},
    },
    {
      id: '221ae476-6e9c-4db0-8b44-63fd3f84dd50',
      type: 'Container',
      runtimeType: null,
      name: '',
      className: 'entrySlot',
      x: 0,
      y: 310,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '5c847bf4-4be3-4f9e-a95c-a8bf7b2073ca',
      data: undefined,
      stateByName: {},
    },
  ],
  version: '1.0.0',
  stateNames: [],
  animations: [],
} as const;

export class TournamentPanelLayout {
  static raw = raw;
  root: Container;
  wrapper: Container;
  joinButton: Container;
  tournamentTitle: Text;
  endsText: Text;
  endsTimeText: Text;
  entriesContainer: Container;
  spinnerSlot: Container;
  entrySlot: Container[];

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: (typeof raw)['list'][0];
      wrapper: (typeof raw)['list'][1];
      joinButton: (typeof raw)['list'][2];
      tournamentTitle: (typeof raw)['list'][4];
      endsText: (typeof raw)['list'][5];
      endsTimeText: (typeof raw)['list'][6];
      entriesContainer: (typeof raw)['list'][7];
      spinnerSlot: (typeof raw)['list'][8];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
